import {ObjectDTO} from "./object-dto";

export class ZoneDeProductionDTO extends ObjectDTO{

  id: number;
  libelle: string;
  actif:boolean;
  code:string;

}
